/**
 * Format file size in bytes to human-readable string using decimal (SI) units
 * This matches how most file managers (Windows, macOS) display file sizes
 * @param bytes - File size in bytes
 * @param decimals - Number of decimal places to show (default: 1)
 * @returns Formatted string (e.g., "6.3 MB", "1.4 GB")
 */
export function formatFileSize(bytes: number | null | undefined, decimals: number = 1): string {
  if (bytes === null || bytes === undefined) {
    return '-'
  }

  if (bytes === 0) {
    return '0 B'
  }

  // Handle negative values (shouldn't happen, but be defensive)
  if (bytes < 0) {
    return '-'
  }

  // Use decimal (SI) units: 1 MB = 1,000,000 bytes (matches file managers)
  const k = 1000
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  // Clamp index to valid range
  const index = Math.max(0, Math.min(i, sizes.length - 1))
  const size = parseFloat((bytes / Math.pow(k, index)).toFixed(dm))

  return `${size} ${sizes[index]}`
}
